module.exports = __webpack_public_path__ + "assets/c5f0e37b750d558e25efd77038e2d1dd.png";